import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get samples of observations
 * Samples are data points at a particular time in the observation, typically ra, dec and timestamp
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getSamples = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  // Add the relevant filters
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(`${API_BASE_URL}/api/samples?${params.toString()}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}
